
import Vue from 'vue'
import UiIcon from '@/components/UiIcon.vue'

export default Vue.extend({
  name: "PostPdfs",
  props: {
    attachments: {
      type: Array,
      default: []
    }
  },
  data(){
    return {
      displayAttachments: []
    }
  },
  components: {
    UiIcon,
  },
})
